import { useTranslation } from '@kostbar/i18n'
import type { ReportMeasure } from '@/features/reports/api/use-sales-report-query'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface MeasureSwitcherProps {
  value: ReportMeasure
  onChange: (measure: ReportMeasure) => void
}

/**
 * Umsatz ↔ Stück (CHG-2026-09-manager-reporting).
 *
 * More than a column: the switch moves the leading figure, the bars **and** the sort order, because
 * the ranking genuinely inverts. In this store food leads by revenue and drinks lead by piece
 * count — whoever decides about prices sees one picture, whoever decides about assortment,
 * reordering and production volume needs the other.
 *
 * The figure it is not showing stays in the table as a secondary column, so nobody has to toggle
 * back to read it.
 *
 * One control per page, above everything it scopes: it is a page-wide switch, never a per-card one.
 */
export function MeasureSwitcher({ value, onChange }: MeasureSwitcherProps) {
  const { t } = useTranslation('reports')
  return (
    <Tabs
      value={value}
      onValueChange={(next) => onChange(next as ReportMeasure)}
    >
      <TabsList aria-label={t('measure.label')}>
        <TabsTrigger value="revenue">{t('measure.revenue')}</TabsTrigger>
        <TabsTrigger value="units">{t('measure.units')}</TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
